// extracted by mini-css-extract-plugin
module.exports = {"spec":"OfferShortSpec_spec__vvor_","one-line":"OfferShortSpec_one-line__kLKJD","clamp":"OfferShortSpec_clamp__jki_L","teal":"OfferShortSpec_teal__uSao9"};